import type { ControllerPlacementCandidateInfo } from "building-types/electrical/candidate";
import type { ControllerSelectionConfig } from "building-types/electrical/controllerSelectionTypes";
import type { Vec2 } from "geom/vec2";
import type { CandidateFilteringCriteria, ControllerSelectionRoomIdFunc } from "../electricalLayoutTypes";

export type ControllerSelectionFunc = (
  controllerSelectionConfig: ControllerSelectionConfig[],
  primaryRoomId: string,
  approximateLoadPosition?: Vec2,
  candidateFilteringCriteria?: CandidateFilteringCriteria,
) => Promise<ControllerPlacementCandidateInfo | null>;

export function convertControllerSelectionFuncToRoomSetIndexFunc(
  func: ControllerSelectionFunc,
  primaryRoomId: string,
): ControllerSelectionRoomIdFunc {
  return async (
    controllerSelectionConfig: ControllerSelectionConfig[],
    approximateLoadPosition: Vec2,
    candidateFilteringCriteria: CandidateFilteringCriteria | undefined,
  ) => {
    return func(controllerSelectionConfig, primaryRoomId, approximateLoadPosition, candidateFilteringCriteria);
  };
}

export function candidateFilteringCriteriaNew(): CandidateFilteringCriteria {
  return {
    candidateIdsToIgnore: [],
    doorIdsToIgnore: [],
  };
}
